<template>
    <Summary/>
</template>
<script>
import Summary from '../components/Summary.ce.vue'

export default {
  name: 'Dashboard-page',
  components: {
    Summary  
  }
}
</script>